import React, { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { 
    Button,
    Container,
    Col,
    Row,
    ListGroup,
    ListGroupItem,
 } from 'reactstrap';
import { actions } from '../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import PluginOfferingList from '../MissionControl/PluginBitwerxOfferings/PluginOfferingList';
import Lock from '../Shared/Lock';
import BitwerxOfferingForm from './BitwerxOfferingForm';
import BitwerxOfferingInfo from './BitwerxOfferingInfo';
import PluginOfferingManagerModal from '../../Modals/MissionControl/PluginOffering/PluginOfferingManagerModal';
import hasPermission from '../../Shared/hasPermission';

const BitwerxOffering = ({ refreshBitwerxOfferings }) => {
    const { bitwerxofferingId } = useParams();
    const dispatch = useDispatch();
    const [bitwerxOffering, setBitwerxOffering] = useState({});
    const [pluginsOffering, setPluginsOffering] = useState([]);
    const [locked, setLocked] = useState(true);
    const [pluginlocked, setPluginLocked] = useState(true);
    const [loading, setLoading] = useState(false);

    const isAddPluginOfferingModalOpen = useSelector(
        (state) => state.toggle.isAddNewPluginOfferingModalOpen
    );

    const toggleLocked = useCallback(() => setLocked(!locked), [locked]);
    const togglePluginLocked = useCallback(() => setPluginLocked(!pluginlocked), [pluginlocked]);

    const { permissions } = useSelector((state) => ({
        permissions: state.auth.permissions,
    }), shallowEqual);

    const canSeePluginOffering = hasPermission(['BitwerxOfferingPluginManagerView'], permissions);
    
    const toggleAddingPlugin = useCallback(
        () => 
            dispatch(actions.toggle.toggleAddNewPluginOfferingModal(!isAddPluginOfferingModalOpen))
        ,[dispatch, isAddPluginOfferingModalOpen]
    );

    const refreshBitwerxOffering = useCallback(() => {
        setLoading(true);
        dispatch(actions.offerings.fetchBitwerxOffering(bitwerxofferingId))
            .then((res) => {

                setBitwerxOffering(res);
                dispatch(actions.missionControl.getPluginsByOffering(res?.name))
                    .then((res) => {
                        setPluginsOffering(res);
                        setLoading(false);
                    })
            })
            .then(() => setLocked(true));
    }, [dispatch, bitwerxofferingId]);

    const refresh = useCallback(({skipOfferingRefresh = false, skipOfferingListRefresh = false}) => {
        if(!skipOfferingRefresh) refreshBitwerxOffering();
        if(!skipOfferingListRefresh) refreshBitwerxOfferings();
    }, [refreshBitwerxOffering, refreshBitwerxOfferings]);

    useEffect(() => {
        setLocked(true);
        setPluginLocked(true);
        setLoading(true);
        refreshBitwerxOffering();
        // eslint-disable-next-line
    }, [bitwerxofferingId]);


    return (
        <>
            <PluginOfferingManagerModal
                isOpen={isAddPluginOfferingModalOpen}
                offering={bitwerxOffering?.name}
                refresh={refresh}
                toggle={toggleAddingPlugin}
            />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1>
                                    {bitwerxOffering?.name ||
                                        'Loading BitwerxOffering'}
                                </h1>
                            </div>
                        </div>
                    </div>
                </section>

                <Container id="dashboard" className="my-4 ov-dashboard">
                    {canSeePluginOffering && (
                        <PluginOfferingList 
                            offeringName={bitwerxOffering?.name || ''}
                            pluginsOffering={pluginsOffering}
                            loading={loading}
                            lockbutton={
                                <Lock
                                    isLocked={pluginlocked}
                                    onClick={togglePluginLocked}
                                    size="2x"
                                />
                            }
                            locked={pluginlocked}
                            button={
                                <Button className="mx-2" color="info" onClick={toggleAddingPlugin}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    &emsp;Add Plugin
                                </Button>
                            } 
                            refreshBitwerxOffering={refreshBitwerxOffering}
                        />
                    )}

                    <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
                        <>
                            <Col lg="12" md="12" sm="12">
                                <div className="d-flex justify-content-between mb-4">
                                    <div>
                                        <h3>
                                            {locked ? '' : 'Editing '}
                                            {bitwerxOffering?.name ||
                                                'Loading BitwerxOffering'}{' - Sub Offerings'}
                                        </h3>
                                    </div>
                                    {hasPermission(
                                        'ModifyBitwerxOfferings',
                                        permissions
                                    ) && (
                                        <Lock
                                            isLocked={locked}
                                            onClick={toggleLocked}
                                            size="2x"
                                        />
                                    )}
                                </div>
                                <div
                                    style={{
                                        maxHeight: '80vh',
                                        overflowY: 'scroll',
                                    }}>
                                    {locked ? (
                                        <BitwerxOfferingInfo>
                                            <ListGroup
                                                style={{
                                                    maxHeight: '60vh',
                                                    overflowY: 'scroll',
                                                }}>
                                                {bitwerxOffering?.subOfferings?.sort((a,b) => {
                                                    return a.name > b.name ? 1 : -1
                                                }).map(
                                                    (so) => (
                                                        <ListGroupItem key={so.id} className={'text-dark offering-plugin-container align-items-center'} >
                                                            <div className="row">
                                                                <div className="col-xs-12 col-12 col-md-12 col-lg-6">
                                                                    <div>
                                                                        <span>Name:</span>
                                                                    </div>
                                                                    <div>
                                                                        <span>{so.name}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-12 col-12 col-md-12 col-lg-6">
                                                                    <div >
                                                                        <span>Display:</span>
                                                                    </div>
                                                                    <div>
                                                                        <span>{so.displayName}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ListGroupItem>
                                                    )
                                                )}
                                            </ListGroup>
                                        </BitwerxOfferingInfo>
                                    ) : (
                                        <BitwerxOfferingForm
                                            bitwerxOffering={bitwerxOffering}
                                            closeForm={toggleLocked}
                                            refresh={refresh}
                                        />
                                    )}
                                </div>
                            </Col>
                        </>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default React.memo(BitwerxOffering);
